import { Routes, Route, Navigate } from "react-router-dom";
import HEADER from "./components/headers/Header";
import HOME from "./components/home/Home";
import { getStateLoaded } from "./store/store";
import FOOTER from "./components/headers/Footer";
import REPORT from "./components/report/Report";

export default function App() {
  var loaded = getStateLoaded();
  return (
    <div className="main">
      <HEADER />
      <div id='top' className="top-container">
        <Routes>
          <Route path="/" element={<HOME />} />
          <Route path="/home" element={<HOME />} />
          <Route path="/report" element={<REPORT />} />
          <Route path="*" element={<HOME />} />
        </Routes>
      </div>
      <FOOTER />
    </div>
  );
}

